import { OpenAIOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import type React from 'react';
import { useLocation } from 'react-router-dom';
import { AvailableBrands } from 'src/components/available-brands/available-brands';
import { IconAliases } from 'src/components/icons/icons-sidebar/icon-aliases';
import { IconGames } from 'src/components/icons/icons-sidebar/icon-games';
import { IconMappedPromoGames } from 'src/components/icons/icons-sidebar/icon-mapped-promo-games';
import { IconPossibleAliases } from 'src/components/icons/icons-sidebar/icon-possible-aliases';
import { IconUnmappedGames } from 'src/components/icons/icons-sidebar/icon-unmapped-games';
import { IconUnmappedPromoGames } from 'src/components/icons/icons-sidebar/icon-unmapped-promo-games';
import { isLlmGameMatchingAvailable, Route } from 'src/constants';
import { useGetPromotedPartnerGames } from 'src/hooks/data/partner-games';
import { SidebarLink } from './sidebar-link/sidebar-link';

export const Sidebar: React.FC = () => {
  const { pathname } = useLocation();
  const { data } = useGetPromotedPartnerGames({ type: 'unmapped', brands: [] });

  return (
    <Layout.Sider width={216} className="px-12 py-16">
      <SidebarLink
        to={Route.UNMAPPED_GAMES}
        isActive={pathname === Route.UNMAPPED_GAMES}
        icon={<IconUnmappedGames />}
        text="Unmapped Games"
      />
      <SidebarLink to={Route.ALIASES} isActive={pathname === Route.ALIASES} icon={<IconAliases />} text="Aliases" />
      <SidebarLink
        to={Route.POSSIBLE_ALIASES}
        isActive={pathname === Route.POSSIBLE_ALIASES}
        icon={<IconPossibleAliases />}
        text="Possible Aliases"
      />
      <SidebarLink to={Route.GAMES} isActive={pathname === Route.GAMES} icon={<IconGames />} text="Games" />
      <SidebarLink
        to={Route.UNMAPPED_PROMO_GAMES}
        isActive={pathname === Route.UNMAPPED_PROMO_GAMES}
        icon={<IconUnmappedPromoGames />}
        text="Unmapped Promo Games"
        extra={
          !!data?.length && (
            <div className="bg-primary text-gray-1 px-4 h-[12px] font-medium rounded-md text-[8px]/[12px]">
              {data?.length}
            </div>
          )
        }
      />
      <SidebarLink
        to={Route.MAPPED_PROMO_GAMES}
        isActive={pathname === Route.MAPPED_PROMO_GAMES}
        icon={<IconMappedPromoGames />}
        text="Promo Games"
      />
      {isLlmGameMatchingAvailable && (
        <SidebarLink
          to={Route.LLM_GAME_MATCHING}
          isActive={pathname === Route.LLM_GAME_MATCHING}
          icon={<OpenAIOutlined className="text-[18px]" />}
          text="Game Matching"
        />
      )}

      <AvailableBrands />
    </Layout.Sider>
  );
};
